export default __webpack_public_path__ + "static/media/Undo.44ee6011.svg";